<mat-card class="linq-card--legacy">
	<sl-filters [filters]="filters" [searchOnly]="true" [hideSearch]="!config.hidePriority" (filtersUpdated)="applyFilter($event)">
		<span class="spacer"></span>
		<button mat-button defaultColor="primary" color="primary" (click)="add()" *ngIf="!config.isReadOnly">
			<mat-icon>add</mat-icon> Add {{config.entityName}}
		</button>
	</sl-filters>
	<sl-table [data]="entities" [config]="tableConfig" [newRow]="newRow" [filters]="filters" (unsavedChanges)="unsavedChanges.emit($event)">
	</sl-table>
</mat-card>

<ng-template #keyTemplate let-row="row" let-column="column" let-fc="fc">
	<mat-form-field>
		<input matInput [placeholder]="column.header() + ' *'" [formControl]="fc" [(ngModel)]="row[column.key]" requiredNoWhitespace maxlength="50"
			[existingDataDuplicateValueValidator]="getOtherKeyValues(row.Id)" />
		<mat-error *ngIf="fc.hasError('required')">{{column.header()}} is required</mat-error>
		<mat-error *ngIf="fc.hasError('duplicateValue')">Record with that {{column.header()}} already exists</mat-error>
	</mat-form-field>
</ng-template>
<ng-template #displayTemplate let-row="row" let-column="column" let-fc="fc">
	<mat-form-field>
		<input matInput [placeholder]="column.header() + ' *'" [formControl]="fc" [(ngModel)]="row[column.key]" requiredNoWhitespace maxlength="75"
			[existingDataDuplicateValueValidator]="getOtherDisplayValues(row.Id)" />
		<mat-error *ngIf="fc.hasError('required')">{{column.header()}} is required</mat-error>
		<mat-error *ngIf="fc.hasError('duplicateValue')">Record with that {{column.header()}} already exists</mat-error>
	</mat-form-field>
</ng-template>
<ng-template #displayTextAreaTemplate let-row="row" let-column="column" let-fc="fc">
	<mat-form-field>
		<textarea matInput [placeholder]="column.header() + ' *'" [formControl]="fc" [(ngModel)]="row[column.key]" requiredNoWhitespace
			maxlength="1000" [existingDataDuplicateValueValidator]="getOtherDisplayValues(row.Id)"></textarea>
		<mat-error *ngIf="fc.hasError('required')">{{column.header()}} is required</mat-error>
		<mat-error *ngIf="fc.hasError('duplicateValue')">Record with that {{column.header()}} already exists</mat-error>
	</mat-form-field>
</ng-template>
<ng-template #displayMonthsTemplate let-row="row" let-column="column" let-fc="fc">
	<mat-form-field>
		<input type="number" matInput [placeholder]="column.header() + ' *'" [formControl]="fc" [(ngModel)]="row[column.key]" required numbersOnly
			[maxDecimalPlacesValidator]="2" [maxlength]="5" [maxValidator]="12"
			[existingDataDuplicateValueValidator]="getOtherDisplayValues(row.Id)" />
		<mat-error *ngIf="fc.hasError('required')">{{column.header()}} is required</mat-error>
		<mat-error *ngIf="fc.hasError('duplicateValue')">Record with that {{column.header()}} already exists</mat-error>
		<mat-error *ngIf="fc.hasError('max')">{{column.header()}} must be 12 or less</mat-error>
		<mat-error *ngIf="fc.hasError('maxDecimalPlaces')">{{column.header()}} must be max of 2 decimal places</mat-error>
	</mat-form-field>
</ng-template>
